import { RELEASE_VERSION } from '~/services/environment/environment';

declare global {
  interface Window {
    RELEASE_VERSION: string;
  }
}

window.RELEASE_VERSION = RELEASE_VERSION;
